/* globals newrelic */
import { setState, getState } from '../state';

export const experienceSSR = () => {
  if (typeof window.__SSR_ERROR !== 'undefined' && window.__SSR_ERROR) {

    const { pathname } = window.location;
    newrelic.addPageAction('SSRError', {
      ssrErrorMessage: window.__SSR_ERROR.error,
      ssrErrorStack: window.__SSR_ERROR.stack,
      pathname
    });
  }
};
